export const services = {
  'seo.title': 'Услуги — Программы Нутрициологического Сопровождения | София и Елена',
  'seo.description': 'Выберите свою программу: VIP-сопровождение Тандем, протокол FMD для клеточного омоложения, детская нутрициология или групповые интенсивы.',
  'seo.keywords': 'услуги нутрициолога, программы питания, VIP сопровождение, протокол FMD, детская нутрициология',

  'hero.title': 'Наши двери',
  'hero.description': 'Каждая программа — это вход в новую версию себя. Выберите свой путь к здоровью и красоте.',

  'service1.title': 'Персональное VIP-сопровождение',
  'service1.subtitle': 'Тандем',
  'service1.description': 'Полное погружение. Ежедневная поддержка. Разбор анализов, работа со стрессом, питание для всей семьи.',
  'service1.feature1': 'Ежедневная поддержка двух экспертов',
  'service1.feature2': 'Глубокий разбор анализов',
  'service1.feature3': 'Работа со стрессом и эмоциональным состоянием',
  'service1.feature4': 'Индивидуальные протоколы питания',
  'service1.feature5': 'Поддержка всей семьи',

  'service2.title': 'Протокол FMD',
  'service2.subtitle': 'Клеточное омоложение',
  'service2.description': '5 дней биохакинга. Минус биологический возраст, плюс бесконечная энергия.',
  'service2.feature1': '5-дневный научный протокол',
  'service2.feature2': 'Клеточное обновление организма',
  'service2.feature3': 'Снижение биологического возраста',
  'service2.feature4': 'Повышение энергии и ясности ума',
  'service2.feature5': 'Детоксикация на клеточном уровне',

  'service3.title': 'Детская нутрициология',
  'service3.subtitle': 'Будущее начинается в тарелке',
  'service3.description': 'Здоровое пищевое поведение с колыбели. Работа с аллергиями, привередливостью и иммунитетом.',
  'service3.feature1': 'Формирование здоровых пищевых привычек',
  'service3.feature2': 'Работа с пищевыми аллергиями',
  'service3.feature3': 'Решение проблемы привередливости в еде',
  'service3.feature4': 'Укрепление иммунитета',
  'service3.feature5': 'Поддержка роста и развития',

  'service4.title': 'Групповые интенсивы',
  'service4.subtitle': 'Энергия комьюнити',
  'service4.description': 'Мягкие протоколы для тех, кто хочет быстрый и качественный старт под нашим присмотром.',
  'service4.feature1': 'Работа в мини-группах 3-4 человека',
  'service4.feature2': 'Энергия и поддержка единомышленников',
  'service4.feature3': 'Структурированные протоколы',
  'service4.feature4': 'Регулярные групповые созвоны',
  'service4.feature5': 'Доступная стоимость',

  'learnMore': 'Узнать больше',
  'learnMoreAria': 'Узнать больше о {{service}}',

  'cta.title': 'Не знаете, что выбрать?',
  'cta.description': 'Запишитесь на бесплатную диагностику, и мы подберем идеальную программу для вас',
  'cta.button': 'Записаться на диагностику',
  'cta.buttonAria': 'Записаться на бесплатную диагностику',
};